import React,{useState} from 'react';
import { useEffect } from 'react';
import { getCookie } from '../../Utils/cookies';
import { useNavigate } from 'react-router-dom';
import farmerExcel from '../../Assets/Excel/farmer.xlsx';
import complaintExcel from '../../Assets/Excel/complaint.xlsx'
import axios from 'axios';

const Index = () => {
  const Navigate = useNavigate();
  useEffect(() => {
      const token = getCookie('token');
      if(!token){
        Navigate('/');
      } 
    }, []);
  const [isUploading, setIsUploading] = useState(false);
  const [message, setMessage] = useState('');
  const [file, setFile] = useState()
  // Handle file selection
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage('Please select a file to upload.');
      return;
    }
    const formData = new FormData();
    formData.append('file', file);

    try {
      setIsUploading(true);
      setMessage('');
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/farmer/addByExcel`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
        setMessage(response.data.message);
    } catch (error) {
      console.log(error)
      setMessage('Error uploading file.');
    } finally {
      setIsUploading(false);
    }
  };

  // for farmer excel download



  // for complaint Data
  const [complaintFile, setComplaintFile] = useState();
  const [messageForComplaint, setMessageForComplaint] = useState();
  const [isUploadForComplaint, setIsUploadForComplaint] = useState(false);
  const handleFileChangeForComplaint = (e) => {
    setComplaintFile(e.target.files[0]);
  };
  const handleSubmitForComplaint = async(e) =>{
    e.preventDefault();
    if (!complaintFile) {
      setMessageForComplaint('Please select a file to upload.');
      return;
    }
    const formData = new FormData();
    formData.append('file', complaintFile);

    try {
      setIsUploadForComplaint(true);
      setMessageForComplaint('');
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/farmer/addComplaintByExcel`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setMessageForComplaint(response.data.message);
    } catch (error) {
      console.log("complaint Upload error",error)
      setMessageForComplaint('Error uploading file.');
    } finally {
      setIsUploadForComplaint(false);
    }
  };
  return (
    <>
      <div className="container  flex flex-col">
        <div className="mainHeading">
            <h1 className='text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50  rounded-lg'>U<span className='text-lg'>PLOAD</span> F<span className='text-lg'>ILE</span></h1>
        </div>
        <div className="formField">
        <form onSubmit={handleSubmit} >
          <div className="grid gap-3 m-6 md:grid-cols-4">
            <div>
              <label for="first_name" className="block mb-2 text-sm font-medium text-gray-900 ">Add Farmer<span className='text-red-500 fixed h-3'>*</span></label>
              <input type="file" onChange={handleFileChange} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2 dark:bg-gray-700 "/>
              <a href={farmerExcel} download="farmer.xlsx" className='text-sm text-blue-600'>Download Format</a>
            </div>

            <div>
              <button type="submit" disabled={isUploading} className="text-dark mt-8 bg-yellow-500 ml-6 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center" onChange={handleFileChange}>
                {isUploading ? 'Uploading...' : 'Upload'}
              </button>
            </div>
          </div>
          {message && ( <p className="mt-4 ml-6 text-2xl text-left text-red-700"> {message} </p>)}
          </form>
        </div>

        {/* for complaint */}
        <div className="formField">
        <form onSubmit={handleSubmitForComplaint} >
          <div className="grid gap-3 m-6 md:grid-cols-4">
            <div>
              <label for="first_name" className="block mb-2 text-sm font-medium text-gray-900 ">Add Complaint<span className='text-red-500 fixed h-3'>*</span></label>
              <input type="file" onChange={handleFileChangeForComplaint} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2 dark:bg-gray-700 "/>
              <a href={complaintExcel} download="Complaint.xlsx" className='text-sm text-blue-600'>Download Format</a>

            </div>
            <div>
              <button type="submit" disabled={isUploading} className="text-dark mt-8 bg-yellow-500 ml-6 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center" onChange={handleFileChange}>
                {isUploadForComplaint ? 'Uploading...' : 'Upload'}
              </button>
            </div>
          </div>
          {messageForComplaint && ( <p className="mt-4 ml-6 text-2xl text-left text-red-700"> {messageForComplaint} </p>)}
          </form>
        </div>
      </div>
    </>
  );
};

export default Index
